import React from "react";
import { IYear } from "../../../utils/api/year/year.type";
import { useCrudYear } from "../../admin/Settings/Tabs/useForm/useCrudYear";
import { Button, CloseModalButton } from "../../shared/Button";
import { Input } from "../../shared/Input";
import Modal, { ModalCrudProps } from "../../shared/Modal";

const AddYearModal = ({ showModal, toggleModal, item }: ModalCrudProps<IYear>) => {
	const { register, onSubmit, errors, isLoading, reset } = useCrudYear(item, toggleModal);
	return (
		<>
			{showModal && (
				<Modal modalTitle={`${item ? "Modifier" : "Ajouter"} une année `}>
					<form action="" onSubmit={onSubmit}>
						<div className="relative p-6 flex-auto">
							<Input
								label="Année"
								placeholder="2022"
								type="text"
								id="annee"
								{...register("name")}
								error={errors?.name}
								defaultValue={item?.name}
							/>
						</div>
						{/*footer*/}
						<div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
							<CloseModalButton
								text="Fermer"
								onClick={() => {
									reset();
									toggleModal();
								}}
							/>
							<Button label="Enregistrer" isLoading={isLoading} />
						</div>
					</form>
				</Modal>
			)}
		</>
	);
};

export default AddYearModal;
